/**
 * @generated SignedSource<<374abf2f8b7aa101c91d06c9ca18de0f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PriceDisplay_activeHold$data = {
  readonly displayTimeToExpire: string | null;
  readonly " $fragmentType": "PriceDisplay_activeHold";
};
export type PriceDisplay_activeHold$key = {
  readonly " $data"?: PriceDisplay_activeHold$data;
  readonly " $fragmentSpreads": FragmentRefs<"PriceDisplay_activeHold">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PriceDisplay_activeHold",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayTimeToExpire",
      "storageKey": null
    }
  ],
  "type": "Hold",
  "abstractKey": null
};

(node as any).hash = "a49b132fe528563c4704be634b36af05";

export default node;
